<template>
  <div class="fill-height d-flex flex-column wrap">
    <div
      class="d-flex justify-space-between font-weight-bold mb-4 align-center"
    >
      <span class="font-weight-bold title">Operator Activity</span>
      <router-link :to="{ name: 'operators' }" class="font-weight-bold title">
        All Operators
        <v-icon color="primary" size="16px">$arrowRight</v-icon>
      </router-link>
    </div>
    <v-card
      class="card-tab overflow-hidden d-flex flex-column wrap justify-space-between flex-2 pa-10 py-4"
    >
      <v-list
        flat
        tile
        dense
        max-height="400"
        class="overflow-auto border-none py-0"
      >
        <v-list-item class="d-flex pa-0 body-1">
          <v-list-item-content class="pa-0">
            <v-list-item-title class="body-1 font-weight-bold">
              Active Operators (Today)
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="my-0 font-weight-bold">
            Total Operators
          </v-list-item-action>
        </v-list-item>
        <v-list-item class="d-flex pa-0 body-1">
          <v-list-item-content class="pa-0">
            <v-list-item-title class="body-1">
              {{ activity.total_active_today }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="my-0">
            {{ activity.total }} ( +{{ activity.total_new_today }} Today )
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-actions
        class="px-0 py-3 text-center justify-lg-space-between d-flex"
      >
        <v-btn
          depressed
          color="blue lighten-5"
          min-width="45%"
          class="primary--text"
          :to="{ name: 'operators', query: { action: 'create' } }"
        >
          New Operator
          <v-icon class="ml-4" right @click="createMode = true">
            $plus
          </v-icon>
        </v-btn>
        <!--        <v-btn depressed color="primary" min-width="45%" class="white&#45;&#45;text">-->
        <!--          Activity Log-->
        <!--        </v-btn>-->
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { getPromise } from '@services/Promise';

export default {
  name: 'OperatorActivity',
  data() {
    return {
      activity: {
        total: '',
        total_active_today: '',
        total_new_today: '',
      },
      fetched: false,
      fetching: false,
    };
  },
  methods: {
    async fetchOperatorsData() {
      this.fetching = true;
      let response = await getPromise('/tourism-operators/overview').catch(
        () => false
      );
      if (response) {
        Object.assign(this.activity, response.data);
      }
      this.fetching = false;
      this.fetched = true;
    },
  },
  async mounted() {
    this.fetchOperatorsData();
  },
};
</script>
